import { AxiosRequestConfig, AxiosResponse, default as _axios } from "axios";
import AuthStore from "../stores/AuthStore";

class axios {
    static get<T>(url: string, config?: any): Promise<AxiosResponse<T>> {
        return _axios.get<T>(url, {
            ...config,
            withCredentials: true,
            headers: {
                ...config?.headers,
                "X-Sales-Context":
                    AuthStore.loggedIn && AuthStore.boxoffice
                        ? "BOXOFFICE"
                        : "ECOMMERCE",
            },
        });
    }

    static patch<T>(
        url: string,
        data?: any,
        config?: any,
    ): Promise<AxiosResponse<T>> {
        return _axios.patch<T>(url, data, {
            ...config,
            withCredentials: true,
            headers: {
                ...config?.headers,
                "X-Sales-Context":
                    AuthStore.loggedIn && AuthStore.boxoffice
                        ? "BOXOFFICE"
                        : "ECOMMERCE",
            },
        });
    }

    static post<T>(
        url: string,
        data?: any,
        config?: any,
    ): Promise<AxiosResponse<T>> {
        return _axios.post<T>(url, data, {
            ...config,
            withCredentials: true,
            headers: {
                ...config?.headers,
                "X-Sales-Context":
                    AuthStore.loggedIn && AuthStore.boxoffice
                        ? "BOXOFFICE"
                        : "ECOMMERCE",
            },
        });
    }

    static delete<T>(
        url: string,
        data?: any,
        config?: any,
    ): Promise<AxiosResponse<T>> {
        return _axios.delete<T>(url, {
            ...config,
            data,
            withCredentials: true,
            headers: {
                ...config?.headers,
                "X-Sales-Context":
                    AuthStore.loggedIn && AuthStore.boxoffice
                        ? "BOXOFFICE"
                        : "ECOMMERCE",
            },
        });
    }
}

export default axios;
